import React from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { EllipsisVerticalIcon } from "@heroicons/react/24/outline";
import { CompanyDataImportJob } from "../../graphql/subscriptions/onCompanyDataImportJob/types";

interface ImportStatusActionMenuProps {
  job: CompanyDataImportJob;
  onDownload: (uuid: string) => void;
  onErrorClick: (error: string) => void;
  onViewLog: (jobId: number) => void;
}

const ImportStatusActionMenu: React.FC<ImportStatusActionMenuProps> = ({
  job,
  onDownload,
  onErrorClick,
  onViewLog,
}) => {
  const hasFile = !!job.file_path;
  const hasError = !!job.error_message;
  const hasLog = !!job.log_stream;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          className={`h-8 w-8 p-0 transition-colors ${
            hasError
              ? "text-red-600 hover:bg-red-50 hover:text-red-700"
              : "hover:bg-gray-200"
          } dark:hover:bg-slate-700`}
          variant="ghost"
        >
          <span className="sr-only">Open menu</span>
          <EllipsisVerticalIcon className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent align="end" className="w-[140px] p-2 bg-white dark:bg-slate-800">
        {hasFile && (
          <DropdownMenuItem
            className="flex items-center px-3 py-2 text-sm cursor-pointer hover:bg-gray-100 dark:hover:bg-slate-700 dark:text-gray-100 transition-colors"
            onClick={() => onDownload(job.uuid)}
          >
            Download File
          </DropdownMenuItem>
        )}

        {hasLog && (
          <DropdownMenuItem
            className="flex items-center px-3 py-2 text-sm cursor-pointer hover:bg-gray-100 dark:hover:bg-slate-700 dark:text-gray-100 transition-colors"
            onClick={() => onViewLog(job.id)}
          >
            View Log
          </DropdownMenuItem>
        )}

        {hasError && (
          <DropdownMenuItem
            className="flex items-center px-3 py-2 text-sm cursor-pointer hover:bg-gray-100 dark:hover:bg-slate-700 dark:text-gray-100 transition-colors"
            onClick={() => onErrorClick(job.error_message as string)}
          >
            View Error
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ImportStatusActionMenu;
